import React from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import dotpics from "../Assets/images/Group.webp";
import CEO_img from "../Assets/images/ceo.jpg";
import nirmalpix from "../Assets/images/Nirmal-Kavaiya.webp";
import { Facebook, Language, LinkedIn, Twitter } from "@mui/icons-material";
import { title } from "../config/Config";


const Team = () => {
    return (
        <>
            <section className="posimyth-section">
                <div className="banner-section">
                    <div className="container-layout">
                        <Row>
                            <Col lg={12}>
                                <div className="first-posi-section">
                                    <div className="our_team_title">
                                        <h5>Our Team</h5>
                                    </div>
                                    <div className="dynamic-details">
                                        <h1>
                                            <span>MEET THE</span> DYNAMIC TEAM BEHIND OUR SUCCESS
                                        </h1>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="second-section-fm">
                    <div className="container-layout">
                        <Row>
                            <Col lg={12}>
                                <div className="second-fm-details">
                                    <div className="second-section-heading">
                                        <h5>The One Who Started with Vision</h5>
                                        <h2>FOUNDING MEMBER</h2>
                                    </div>
                                    <div className="second-sagarpatel">
                                        <div className="sagar-pic">
                                            <img src={CEO_img} width="60%" alt="sagar" />
                                        </div>
                                        <div className="sagar-patel-details">
                                            <div className="sagar-title">
                                                <h3>Surinder Singh</h3>
                                                <h5>Founder & CEO, {title}</h5>
                                            </div>
                                            <p>
                                                He is the driving force behind Posimyth, leading the
                                                company with innovation, vision, and a relentless pursuit
                                                of excellence.
                                            </p>
                                            <div className="sagar-links">
                                                <div className="double-links">
                                                    <div className="linkedin">
                                                        <LinkedIn />
                                                        <Link to="#">Let's Connect on Linkedln</Link>
                                                    </div>
                                                    <div className="linkedin">
                                                        <Facebook />
                                                        <Link to="#">Get update from Facebook</Link>
                                                    </div>
                                                </div>
                                                <div className="double-links2">
                                                    <div className="twitter">
                                                        <Twitter />
                                                        <Link to="#">Follow Me on twitter</Link>
                                                    </div>
                                                    <div className="twitter">
                                                        <Language />
                                                        <Link to="#">My Stories - Coming Soon</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="third-section-geeks">
                    <div className="container-layout">
                        <div className="geek-heading">
                            <h5>The Geek Squad</h5>
                            <h2>DEVELOPERS</h2>
                        </div>
                        <Row className="third-row-section">
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={3} md={4} sm={6}>
                                <div className="nirmal-details">
                                    <div className="dot-pics">
                                        <img src={dotpics} alt="group" />
                                    </div>
                                    <div className="nirmal-pic">
                                        <img src={nirmalpix} alt="nirmal" />
                                    </div>
                                    <div className="nirmal-info">
                                        <Accordion>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header>Nirmal Kavaiya</Accordion.Header>
                                                <Accordion.Body>
                                                    <h6>Tecnical Product Manager</h6>
                                                    <p>
                                                        If you could only use one emoji for the rest of your
                                                        life what would it be?
                                                    </p>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

            </section>
        </>
    );
}

export default Team;
